module.exports = __webpack_public_path__ + "static/media/logoIphone.7350cf99.png";